import Index from './Index.vue';

export const routes = [
  {
    path: 'indicacoes',
    name: 'talkvia_referrals',
    meta: {
      permissions: ['administrator'],
      superAdminOrAdmin: true,
    },
    component: Index,
  },
];
